import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const HeroSection = () => {
  const { t } = useTranslation();
  const trustBadgeRef = useScrollReveal();
  const titleRef = useScrollReveal();
  const descRef = useScrollReveal();

  return (
    <section id="home" className="hero">
      <div className="container">
        <h1 ref={titleRef} className="fade-in-up scroll-reveal">
          {t('hero.title').split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index === 0 && <br />}
            </React.Fragment>
          ))}
        </h1>
        <div ref={trustBadgeRef} className="trust-badge fade-in-up scroll-reveal">
          <FontAwesomeIcon icon={faShieldAlt} />
          <span>{t('hero.trustBadge')}</span>
        </div>
        <p ref={descRef} className="fade-in-up scroll-reveal">
          {t('hero.description').split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < t('hero.description').split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
